export default __webpack_public_path__ + "static/media/Tapclicks.10292692.png";